module.exports = __webpack_public_path__ + "img/k-red-woman-front.526e48ad.jpg";